import { render, staticRenderFns } from "./LanguageEdit.vue?vue&type=template&id=4d1943b2&scoped=true"
import script from "./LanguageEdit.vue?vue&type=script&lang=js"
export * from "./LanguageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1943b2",
  null
  
)

export default component.exports